import { ReactElement } from 'react'

import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'

const ShareSectionHeading = ({
  title,
  subtitle,
}: {
  title: ReactElement
  subtitle: ReactElement
}) => (
  <span className="flex flex-col gap-1">
    <Title size="XS">{title}</Title>
    <Paragraph>{subtitle}</Paragraph>
  </span>
)

export default ShareSectionHeading
